import { RotateCcw } from "lucide-react";
import { resetMountedFilters, useDirtyFilters } from "@/lib/persistedFilters";

/** Shown next to the breadcrumbs whenever this page's filters differ from their defaults (they're remembered per tab). */
export function RememberedFiltersPill() {
  const dirty = useDirtyFilters();
  if (!dirty.length) return null;
  return (
    <button type="button" onClick={resetMountedFilters} title="Filters on this page are remembered until you close this tab"
            className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-600 shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900"
            data-testid="clear-remembered-filters-button">
      <RotateCcw className="h-3 w-3" /> Clear filters
    </button>
  );
}
